export enum ComponentType {
  BinaryDecision = 'binary_decision',
  FileUpload = 'file_upload',
  FormFields = 'form_fields',
  HorizontalFormField = 'horizontal_form_field',
  Review = 'review',
  SelectSubSelect = 'select_sub_select',
  SingleFormField = 'single_form_field',
  TermsAndConditions = 'terms_and_conditions',
  VerticalFormField = 'vertical_form_field',
  YesNoDecision = 'yes_no_decision',
  CheckboxFormField = 'checkbox_form_field',
  RadioFormField = 'radio_form_field',
  DnpeLookup = 'dnpe_lookup'
}
